import * as React from "react";
import { DateInput } from "./dateInput";
import { getJavaDateTime, stringInputParseDateTime, stringInputFormatDateTime } from "./baseFormating";
import { parseISO } from "date-fns";
import { TimePrecision } from "./timePicker";
import { csLocalizer } from "./csLocalizer";

type BaseDateProps = React.ComponentProps<typeof DateInput>;
export type IStringDateTimeInputProps = Omit<
    BaseDateProps,
    "value" | "onBlur" | "onFocus" | "onChange" | "formatDate" | "parseDate"
> & {
    value: string;
    onChange?: (newValue: string) => void;
    onFocus?: (newValue: string) => void;
    onBlur?: (newValue: string) => void;
    disabled?: boolean;
    required?: boolean;
};

export class StringDateTimeInput extends React.PureComponent<IStringDateTimeInputProps> {
    render() {
        const {
            value,
            onChange,
            timePickerProps,
            onBlur,
            onFocus,
            disabled,
            required,
            inputProps,
            ...other
        } = this.props;
        const realValue: Date | null = value === "" || value === null || value === undefined ? null : parseISO(value);
        return (
            <DateInput
                timePrecision={TimePrecision.MINUTE}
                localeUtils={csLocalizer}
                closeOnSelection={false}
                {...other}
                onChange={selectedDate => {
                    if (selectedDate instanceof Date && isNaN(selectedDate as any)) {
                        // ignore change - leave last valid date
                    } else if (selectedDate === null) {
                        onChange?.("");
                    } else {
                        onChange?.(getJavaDateTime(selectedDate));
                    }
                }}
                onBlur={selectedDate => {
                    onBlur?.(getJavaDateTime(selectedDate));
                }}
                onFocus={selectedDate => {
                    onFocus?.(getJavaDateTime(selectedDate));
                }}
                value={realValue}
                formatDate={stringInputFormatDateTime}
                parseDate={stringInputParseDateTime}
                timePickerProps={{
                    showArrowButtons: true,
                    ...(timePickerProps || {}),
                }}
                disabled={disabled}
                inputProps={{ ...inputProps, disabled, required }}
            />
        );
    }
}
